import http from '../http-common'

export default {
    async loadOrgs() {
        let orgList = []
        await http.get('/org/list')
            .then((response) => {
                orgList = response.data;
                orgList.forEach(function (x) {
                    x.value = x.id;
                    x.text = x.shortName;
                })
            })
            .catch((error) => console.log(error.message));
        return orgList
    },
    async loadEkpTypes() {
        let ekpTypeList = []
        let response = await http.get('/workkind/EKP_TYPE/option').then()
            .catch((error) => console.log(error.message));
        ekpTypeList = response.data;
        return ekpTypeList
    },
    async loadKind() {
        let kindList = [];
        await http.get('/sportkind/list')
            .then((response) => {
                kindList = response.data;
                kindList.forEach(function (x) {
                    x.value = x.id;
                    x.text = x.name;
                })
                return kindList
            })
            .catch((error) => console.log(error.response.data));
        return kindList
    },
    async loadAgeKind() {
        let ageKindList = []
        let opt = {value: null, text: '-- Выберите возрастную категорию --', disabled: true}
        ageKindList.push(opt);
        await http.get('/workkind/AGE_KIND/list')
            .then((response) => {
                response.data.forEach( function (x) {
                    var rec = {}
                    rec.value = x.id;
                    rec.text = x.shortName;
                    ageKindList.push(rec);
                })
            })
            .catch((error) => console.log(error.message))
        return ageKindList
    },
    async loadJobKind() {
        let jobKindList = [];
        await http.get('/workkind/JOB_KIND/option')
            .then((response) => {
                jobKindList = response.data;
            })
            .catch((error) => console.log(error.response.data));
        return jobKindList
    },
    async loadFederations() {
        let fedList = [];
        await http.get('/federation/list')
            .then((response) => {
                fedList = response.data;
                fedList.forEach(function (x) {
                    x.value = x.id;
                    x.text = x.shortName;
                })
            })
            .catch((error) => console.log(error.response.data));
        return fedList
    },
    async loadLocation() {
        let locList = [];
        await http.get('/location/list')
            .then((response) => {
                locList = response.data;
                locList.forEach(function (x) {
                    x.value = x.id;
                    x.text = x.nameObj;
                })
            })
            .catch((error) => console.log(error.response.data));
        return locList
    },
    async loadEventKind() {
        let eventKindList = [];
        await http.get('/eventkind/list')
            .then((response) => {
                eventKindList = response.data;
                eventKindList.forEach(function (x) {
                    x.value = x.id;
                    x.text = x.nameKind;
                })
            })
            .catch((error) => console.log(error.response.data));
        return eventKindList
    },
    async loadEventState() {
        let eventstateList = [];
        await http.get('/eventstate/list')
            .then((response) => {
                eventstateList = response.data;
                eventstateList.forEach(function (x) {
                    x.value = x.id;
                    x.text = x.nameState;
                })
            })
            .catch((error) => console.log(error.response.data));
        return eventstateList
    },
}
